var map = {
	"./en": [
		"mtZG",
		3
	],
	"./en.json": [
		"mtZG",
		3
	],
	"./sw": [
		"65rJ",
		2
	],
	"./sw.json": [
		"65rJ",
		2
	],
	"./tz-sw": [
		"OvN8",
		1
	],
	"./tz-sw.json": [
		"OvN8",
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "lgBR";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang lazy ^\.\/.*$
// module id = lgBR
// module chunks = 26